import { render } from "./CoachPage.vue?vue&type=template&id=77a9136a&scoped=true"
import script from "./CoachPage.vue?vue&type=script&lang=js"
export * from "./CoachPage.vue?vue&type=script&lang=js"

import "./CoachPage.vue?vue&type=style&index=0&id=77a9136a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a9136a"]])

export default __exports__